import { useState, useEffect } from 'react'

export function useTelegramWebApp() {
  const [tg, setTg] = useState(null)
  const [initData, setInitData] = useState(null)
  const [isReady, setIsReady] = useState(false)

  useEffect(() => {
    // Check if Telegram WebApp is available
    if (window.Telegram && window.Telegram.WebApp) {
      const telegramWebApp = window.Telegram.WebApp
      
      // Initialize Telegram WebApp
      telegramWebApp.ready()
      telegramWebApp.expand()
      
      setTg(telegramWebApp)
      setInitData(telegramWebApp.initData || telegramWebApp.initDataUnsafe)
      setIsReady(true)

      // Listen for theme changes
      telegramWebApp.onEvent('themeChanged', () => {
        // Force re-render on theme change
        setTg({ ...telegramWebApp })
      })

      // Listen for viewport changes
      telegramWebApp.onEvent('viewportChanged', () => {
        telegramWebApp.expand()
      })
    } else {
      // Fallback for development (not in Telegram)
      console.warn('Telegram WebApp not available. Running in development mode.')
      setIsReady(true)
    }
  }, [])

  return {
    tg,
    initData,
    isReady,
    // Helper methods
    sendData: (data) => tg?.sendData?.(JSON.stringify(data)),
    showAlert: (message) => tg?.showAlert?.(message),
    showConfirm: (message) => tg?.showConfirm?.(message),
    close: () => tg?.close?.(),
  }
}

